import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { SelectSearchModule } from '../../fi-select-search/select-search.module';
import { FiCountriesSelectComponent } from './fi-countries-select.component';
import { FiAppTextSharedModule } from '../../app-text';
import { MatInput } from '@angular/material/input';
import { FiCountryHelperService } from '@fi-shared/fi-contacts/fi-countries-select/country-helper.service';
import { CountryService } from '@fi-shared/fi-contacts/fi-countries-select/country.service';

@NgModule({
    imports: [CommonModule, FormsModule, SelectSearchModule, FiAppTextSharedModule, MatInput],
    declarations: [FiCountriesSelectComponent],
    exports: [FiCountriesSelectComponent],
    providers: [FiCountryHelperService, CountryService],
})
export class FiCountriesSelectModule {}
